<script>
  import { currentLanguage } from "../../store";
  import translations from "../../translations";

  export let currentStep = "booking";
  export let contactFirst = false;

  let currentLang = navigator.language.split("-")[0] || "en";

  currentLanguage.subscribe((language) => {
    currentLang = language;
  });

  $: steps = contactFirst
    ? [
        { id: "contact", label: translations.bookingStepContact[currentLang] || translations.bookingStepContact.en },
        { id: "booking", label: translations.bookingStepBooking[currentLang] || translations.bookingStepBooking.en },
        { id: "confirmation", label: translations.bookingStepConfirmation[currentLang] || translations.bookingStepConfirmation.en },
      ]
    : [
        { id: "booking", label: translations.bookingStepBooking[currentLang] || translations.bookingStepBooking.en },
        { id: "contact", label: translations.bookingStepContact[currentLang] || translations.bookingStepContact.en },
        { id: "confirmation", label: translations.bookingStepConfirmation[currentLang] || translations.bookingStepConfirmation.en },
      ];
  $: activeIndex = Math.max(0, steps.findIndex((step) => step.id === currentStep));
</script>

<nav class="chatwith-booking-steps" aria-label="Booking progress">
  {#each steps as step, index}
    <div
      class="chatwith-booking-step"
      class:active={index === activeIndex}
      class:complete={index < activeIndex}
      aria-current={index === activeIndex ? "step" : undefined}
    >
      <span class="chatwith-booking-step-number">{index < activeIndex ? "✓" : index + 1}</span>
      <span class="chatwith-booking-step-label">{step.label}</span>
    </div>
    {#if index < steps.length - 1}
      <span class:complete={index < activeIndex} class="chatwith-booking-step-line" aria-hidden="true"></span>
    {/if}
  {/each}
</nav>
